import React from 'react'
import propTypes from 'prop-types'
import { Line } from 'react-chartjs-2'
import { buildChartJsOptionsProp } from './options'
import { buildChartjsDataProp } from './data'

import { getChartHeight } from '@utils/heights'

export const LineChartStacked = ({ className, labels, data, options, height }) => {
  return (
    <div className={className} style={{ height: getChartHeight(height) }}>
      <Line
        options={buildChartJsOptionsProp(options)}
        data={buildChartjsDataProp(labels, data)}
      />
    </div>
  )
}

LineChartStacked.propTypes = {
  className: propTypes.string,
  labels: propTypes.array.isRequired,
  data: propTypes.array.isRequired,
  height: propTypes.string,
  options: propTypes.object
}

LineChartStacked.defaultProps = {
  className: '',
  labels: [],
  data: [],
  height: '',
  options: {}
}

